import { AddToList } from 'src/app/modules/customer-data/customers/models/member-summary.models';
import { FilterData } from '../components/wizard/steps/who/helpers/filter-template-data';
import { CampaignAttribute } from './campaign-add-attributes.interface';
import { campaignAdHocListAction } from './campaign-adhoc-list.interface';
import { CampaignAdhocPoints } from './campaign-adhoc-points.interface';
import { CampaignCoupon } from './campaign-coupon.interface';
import { CampaignEmail } from './campaign-email.interface';
import { CampaignTag } from './campaign-give-tags.interface';
import { CampaignInAppMessage } from './campaign-in-app-message.interface';
import { CampaignPushNotification } from './campaign-push-notification.interface';
import { CampaignSMS } from './campaign-sms.interface';
import { CampaignFlow } from './campaign-trigger-flow.interface';
import { CampaignViber } from './campaign-viber.interface';

export enum WizardStep {
  Setup = 'setup',
  Who = 'who',
  What = 'what',
  When = 'when',
  Configuration = 'configuration',
}

export const WIZARD_STEPS_ORDER = [
  WizardStep.Setup,
  WizardStep.Who,
  WizardStep.What,
  WizardStep.When,
  WizardStep.Configuration,
];

export interface CampaignCategory {
  id: number;
  description: string;
}

export interface CampaignEnums {
  campaignCommunicationChannels: string[];
  campaignExportDataSelections: string[];
  campaignEventTypes: string[];
  operators: string[];
  genders: string[];
  statusTypes: string[];
  campaignSelectionTargetEnum: string[];
  campaignTestFunctionalities: string[];
}

export interface WizardState {
  currentStepIndex: number;
  campaignSelectionTarget: string;
  disableNextButton: boolean;
  campaignName: string;
  campaign: any;
  campaignCategories: CampaignCategory[];
  campaignCategoryId: number | null;
  campaignId: number | null;
  isUpdate: boolean;
}

export interface WizardSetupState {
  campaignSelectionTarget: string;
  campaignSchema: string;
  campaignCountry: string;
  campaignSelectionTargetErrorMessage: string;
  showCampaignSelectionTargetErrorMessage: boolean;
  countries: Country[];
  schemas: Schema[];
  countryErrorMessage: string;
  schemaErrorMessage: string;
  showCountryErrorMessage: boolean;
  showSchemaErrorMessage: boolean;
  helpTextStatus: boolean;
  hasClickedNext: boolean;
}

export interface WizardWhoState {
  helpTextStatus: boolean;
  advancedHelpTextStatus: boolean;
  targetGroupFiltersPanelExpanded: boolean;
  advancedFilterConfigurationPanelExpanded: boolean;
  additionalRecipientsPanelExpanded: boolean;
  filterModalOpened: boolean;
  selections: string[];
  memberCategories: MemberCategory[];
  cardTypes: string[];
  siriusAccounts: any;
  socialMediaProviders: string[];
  stores: Store[];
  campaignAdhocLists: CampaignAdhocList[];
  selectedCampaignAdhocList: CampaignAdhocList | null;
  selectedCampaignAdhocListName: string;
  adhocListPreview: AdhocListLine | null;
  selectedFilters: FilterData[];
  showFilterInfo: boolean;
  controlGroupPercentage: number;
  recipientLimit: number | null;
  disableEstimationResultButton: boolean;
  filterConfirmationModalSource: string;
  campaignEstimationIdentifier: CampaignEstimationIdentifier | null;
  estimationResult: EstimationResult | null;
  estimationPolling: boolean;
  searchedCampaigns: any[];
  optOutFlags: OptOutFlags;
  memberStatuses: MemberStatus[];
  couponSets: CouponSet[];
  attributeCodes: AttributeCodes[];
  pointSources: PointSource[];
  memberSources: MemberSource[];
  availableLanguages: AvailableLanguage[];
  memberClubs: MemberClub[];
  tags: Tag[];
  communicationChannels: string[];
  tiers: Tier[];
  rfm: RFM[];
  countries: CountryRegion[];
  regions: Region[];
  mtv: MTV[];
  personSources: MemberSource[];
  reportedEmailCampaigns: ReportedCampaign[];
  reportedInAppCampaigns: ReportedCampaign[];
  reportedPushCampaigns: ReportedCampaign[];
  genericActivityTypes: GenericActivityTypes | null;
  productCategoryLevels: string[];
  productCategories: { [key: string]: string };
}

export interface WizardWhatState {
  helpTextStatus: boolean;
  selectedActionTypes: CampaignActionType[];
  actionConfigs: Partial<Record<CampaignActionType, any>>;
  nexusAccounts: NexusAccount[];
  selectedSmsLanguages: string[];
  selectedViberLanguages: string[];
  selectedInAppLanguages: string[];
  campaignSms: CampaignSMS;
  campaignViber: CampaignViber;
  campaignEmail: CampaignEmail;
  campaignPushNotification: CampaignPushNotification;
  campaignInAppMessage: CampaignInAppMessage;
  campaignCoupon: CampaignCoupon;
  campaignAdHocPoint: CampaignAdhocPoints;
  campaignAdHocListAction: campaignAdHocListAction;
  campaignReport: boolean;
  campaignAttribute: CampaignAttribute;
  campaignEmarsysConfig: null;
  campaignFlow: CampaignFlow;
  campaignTag: CampaignTag;
  apifonSMSAccounts: Account[];
  apifonViberAccounts: Account[];
  mstatViberAccounts: Account[];
  omniViberAccounts: Account[];
  mailChimpAccounts: Account[];
  enboxAccounts: Account[];
  contactPigeonAccounts: Account[];
  aws_sesAccounts: Account[];
  pushNotificationAccounts: Account[];
  inAppMessageAccounts: Account[];
  memberAttributeCodes: AttributeCode[];
  personAttributeCodes: AttributeCode[];
  senderEmailAddresses: string[];
  senderNames: string[];
  couponSets: CouponSet[];
  couponSetFilter: string;
  couponActions: string[];
  pointSources: PointSource[];
  tags: Tag[];
  flows: Flow[];
  adhocListData: AddToList[];
  selectedActionType: ActionType;
  selectedTestViberCampaignAdhocList: CampaignAdhocList | null;
  selectedTestFallbackSmsCampaignAdhocList: CampaignAdhocList | null;
  selectedTestSmsCampaignAdhocList: CampaignAdhocList | null;
  enableViberActionButtons: boolean;
  enableFallbackSmsActionButtons: boolean;
  enableSmsActionButtons: boolean;
}

export interface WizardWhenState {
  helpTextStatus: boolean;
  selectedWhenType: string;
  selectedTimezone: string;
  schedules: ScheduleConfig[];
  onceOffDates: string[];
  pendingOnceOffDate: any;
  campaignWhen: CampaignWhenDTO;
}
export interface WizardConfigurationState {
  helpTextStatus: boolean;
  campaignName: string;
  channels: string[];
  channel: string;
  statusList: string[];
  status: string;
  priorities: string[];
  priority: string;
  description: string;
  exportDataSelections: string[];
  selectedExportDataSelections: string[];
  startDate: string;
  endDate: string;
  notes: string;
}

export interface CampaignWhenDTO {
  campaignEventTypeList: any[] | null;
  campaignScheduleList: any[];
  campaignOnceOffList: any[];
}

export interface ScheduleConfig {
  frequency: string;
  minute: string;
  hour: string;
  dayOfWeek: string;
  dayOfMonth: string;
  month: string;
}

export interface TimezoneGroup {
  continent: string;
  zones: string[];
}

export interface AttributeCode {
  attributeType: string;
  attributeNames: string[];
}

export type CampaignActionType =
  | 'SMS'
  | 'VIBER'
  | 'EMAIL'
  | 'PUSH_NOTIFICATION'
  | 'IN_APP_MESSAGE'
  | 'COUPON'
  | 'POINTS'
  | 'LIST'
  | 'RECORD'
  | 'TAG'
  | 'FLOW'
  | 'ATTRIBUTE';

export interface NexusAccount {
  nexusAccountId: number;
  defaultSender: string;
  nexusUserName: string;
  description: any;
  costPerSMS: number;
}

export interface Account {
  name: string;
  displayName: string;
}

export interface Language {
  languageId: string;
  languageCode: string;
  languageName: string;
}

export interface SmsTabConfig {
  nexusAccountId: string | null;
  selectedLanguages: string[];
  messages: Record<string, string>;
  memberAttributes: any[];
  testListId: string | null;
}

export interface Country {
  id: number;
  countryCode: string;
  country: string;
}

export interface Schema {
  id: number;
  loyaltySchemaCode: string;
  loyaltySchemaName: string;
}

export interface MemberCategory {
  tableMemberCategoryId: number;
  memberCategory: string;
  code: string;
}

export interface Store {
  id: number;
  description: string;
}

export interface CampaignAdhocList {
  campaignAdHocListId: number;
  listName: string;
  campaignSelectionTarget: string;
  listNotes: string;
  listCount: number;
  deleteFlag: boolean;
  listType: any;
  attributeName: any;
  attributeDataType: any;
}

export interface AdhocListLine {
  id: number;
  lastName: any;
  firstName: any;
  loyaltyCard: string;
  points: any;
  schemaId: number;
  smsOptOut: boolean;
  emailOptOut: boolean;
}

export interface CanvasItem {
  id: number;
  filterData: any;
}

export interface FilterGroup {
  id: number;
  canvasItems: CanvasItem[];
}

export interface CampaignEstimationIdentifier {
  campaignEstimationIdentifier: string;
}

export interface EstimationResult {
  estimationResult: number;
  additionalRecipients: number;
  controlGroupEstimationResult: number;
}

export interface CouponSet {
  couponSetType: string;
  couponSetId: number;
  loyaltySchemaId: number;
  couponSetCategoryId: any;
  code: string;
  title: string;
  autoGenerated: boolean;
  oncePerYear: boolean;
  remarks: any;
  activeFrom: any;
  activeUntil: any;
  global: boolean;
  reusable: boolean;
  inactive: boolean;
  duration: number;
  durationInMonths: any;
  bookCoupon: any;
  merchantQCCode: any;
  bookCouponTemplate: any;
  couponGenerationParams: any;
  availableVirtualCoupons: number;
  availableNonVirtualCoupons: number;
  attributes: Attribute[];
  tiers: TierConfig[];
  amount: number;
}

export interface Attribute {
  attributeType: string;
  attributeName: string;
  attributeValue: any;
}

export interface TierConfig {
  tierCode: string;
  config: CouponConfig;
}
export interface Tier {
  code: string;
  title: string;
}

export interface CouponConfig {
  couponGenerator: string;
  couponCodeGeneratorSeed: number;
  couponActivationDelayInDays: number;
  couponLimit: number;
}

export interface PointSource {
  loyaltyPointSourceId: number;
  loyaltyPointSourceDescription: string;
}

export interface Tag {
  tagId: number;
  tagLable: string;
  tagCode: string;
}

export interface Flow {
  flowId: string;
  flowName: string;
}

export interface OptOutFlags {
  VIBER: OptOutFlag[];
  SMS: OptOutFlag[];
  EMAIL: OptOutFlag[];
}

export interface OptOutFlag {
  displayName: string;
  name: string;
}

export interface MemberStatus {
  tableMemberStatusId: number;
  loyaltyMemberStatusName: string;
  code: string;
}

export interface AttributeCodes {
  attributeCodes: AttributeCode[];
  entityType: string;
}

export interface MemberSource {
  id: number;
  code: string;
  description: string;
}

export interface AvailableLanguage {
  languageId: number;
  languageCode: string;
  languageName: string;
}

export interface MemberClub {
  clubCode: string;
  clubId: number;
  clubName: string;
}

export interface RFM {
  id: string;
  segment: string;
  rfmStarSequence: number;
}

export interface CountryRegion {
  countryId: number;
  country: string;
  countryCode: string;
  countryCallCode: string;
  mobileNumberValidationPattern: string;
  currency: string;
  currencyCode: string;
  countryLangCode: string;
}

export interface Region {
  id: number;
  deleteFlag: boolean;
  code: string;
  text: string;
}

export interface MTV {
  id: number;
  segment: string;
}

export interface ReportedCampaign {
  campaignId: number;
  data: {
    campaignName: string;
  };
}

export interface GenericActivityTypes {
  subtypes: string[];
  labels: { [key: string]: string };
}

export type ActionType = 'VIBER' | 'SMS' | 'FALLBACK_SMS' | null;

export interface CampaignTestPayload {
  actionType: ActionType;
  campaignId: number | null;
  campaignAdHocListId: number | null | undefined;
}
